/* eslint-disable */
__webpack_public_path__ = CONF.BASE_URL + 'js/';
/* eslint-enable */
